<template>
	<v-slide-y-reverse-transition>
		<div
			v-if="cookieBannerVisible"
			id="cookies-policy"
			class="col-padding row-padding"
		>
			<MainColumn>
				<div class="cookie-content">
					<div class="cookie-text">
						<p>
							Questo sito utilizza i cookie per migliorare la tua esperienza di navigazione. 
							I cookie tecnici sono necessari per il funzionamento del sito, mentre 
							i cookie analitici e funzionali ci aiutano a migliorare il servizio.
						</p>
						<a 
							href="https://www.comune.lucca.it/progetti/cookie-policy/" 
							target="_blank" 
							rel="noopener noreferrer"
							class="cookie-link"
							@click.stop
						>
							Leggi la Cookie Policy del Comune di Lucca
						</a>
					</div>
					
					<div class="cookie-buttons">
						<span 
							@click="rejectCookies"
							class="cookies-policy-btn btn-reject"
						>
							Solo necessari
						</span>
						<span 
							@click="acceptAllCookiesHandler"
							id="cookies-policy-btn"
							class="cookies-policy-btn btn-accept"
						>
							Accetta tutti
						</span>
					</div>
				</div>
			</MainColumn>
		</div>
	</v-slide-y-reverse-transition>
</template>

<script>
import MainColumn from "@/components/ui/MainColumn.vue";
import { mapState, mapActions } from 'vuex';

export default {
	components: {
		MainColumn,
	},
	computed: {
		...mapState(['cookieBannerVisible'])
	},
	mounted() {
		// Migrazione dal vecchio sistema
		this.migrateOldCookies();
		
		// Carica i consensi salvati o mostra il banner
		this.loadCookieConsent();
	},
	methods: {
		...mapActions([
			'loadCookieConsent',
			'acceptAllCookies',
			'rejectOptionalCookies'
		]),
		
		// Migra i vecchi cookie al nuovo sistema
		migrateOldCookies() {
			const oldCookie = this.readCookie('acceptCookies');
			if (oldCookie) {
				// Se aveva accettato con il vecchio sistema, accetta tutto
				const consents = {
					necessary: true,
					analytics: true,
					functionality: true
				};
				this.$store.commit('setAllCookieConsent', consents);
				this.$store.commit('setCookieBannerVisible', false);
				localStorage.setItem('cookieConsent', JSON.stringify(consents));
				localStorage.setItem('cookieConsentGiven', 'true');
			}
		},
		
		// Legge i vecchi cookie
		readCookie(name) {
			let ca = document.cookie.split(";");
			let result = 0;
			result = ca.filter((cookie) => {
				return cookie.includes(name);
			});
			return result.length;
		},
		
		acceptAllCookiesHandler() {
			this.$store.dispatch('acceptAllCookies');
			// Ricarica la pagina per attivare Google Analytics
			window.location.reload();
		},
		
		rejectCookies() {
			this.$store.dispatch('rejectOptionalCookies');
		}
	}
};
</script>

<style lang="scss" scoped>
#cookies-policy {
	padding: 20px 0;
	font-size: $font-size-12;
	position: fixed;
	bottom: 0;
	z-index: 10000;
	background: rgba(0, 0, 0, 0.9);
	width: 100%;
	color: #fff;
}

.cookie-content {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 30px;
}

.cookie-text {
	flex: 1;
	
	p {
		margin: 0 0 10px 0;
		font-size: 14px;
		line-height: 1.6;
		color: #fff;
	}
}

.cookie-link {
	font-size: 13px;
	color: #fff;
	text-decoration: underline;
	display: inline-block;
	
	&:hover {
		color: #497dd6;
	}
}

.cookie-buttons {
	display: flex;
	gap: 15px;
	flex-shrink: 0;
	align-items: center;
}

.cookies-policy-btn {
	font-weight: bold;
	color: #fff;
	text-decoration: underline;
	padding: 8px 20px;
	text-align: center;
	cursor: pointer;
	white-space: nowrap;
	transition: all 0.2s ease;
	
	&:hover {
		color: #497dd6;
	}
}

.btn-reject {
	opacity: 0.8;
	
	&:hover {
		opacity: 1;
	}
}

.btn-accept {
	background: rgba(73, 125, 214, 0.3);
	border: 1px solid #497dd6;
	border-radius: 4px;
	
	&:hover {
		background: rgba(73, 125, 214, 0.5);
	}
}

// Responsive
@media only screen and (max-width: 768px) {
	#cookies-policy {
		padding: 15px 0;
	}
	
	.cookie-content {
		flex-direction: column;
		align-items: stretch;
		gap: 15px;
	}
	
	.cookie-text {
		p {
			font-size: 13px;
		}
		
		.cookie-link {
			font-size: 12px;
		}
	}
	
	.cookie-buttons {
		flex-direction: column;
		gap: 10px;
		
		.cookies-policy-btn {
			width: 100%;
			padding: 12px 20px;
		}
	}
}

@media only screen and (max-width: 480px) {
	.cookie-text {
		p {
			font-size: 12px;
		}
	}
}
</style>